<template>
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6969 10.3363C12.217 9.85628 11.6252 9.55456 11.0046 9.43081V0H2.48233L0.332764 2.14959V13.7877H7.22117C7.38376 14.2491 7.64886 14.6721 8.00504 15.0283C8.63167 15.6549 9.46483 16 10.351 16C11.2372 16 12.0704 15.6549 12.6969 15.0282C13.9905 13.7347 13.9905 11.6299 12.6969 10.3363ZM2.7932 1.01497V2.46044H1.34773L2.7932 1.01497ZM1.27026 12.8502V3.39797H3.7307V0.9375H10.0671V9.37844C9.31451 9.4425 8.5797 9.76163 8.00504 10.3363C7.37839 10.9629 7.03329 11.7961 7.03329 12.6823C7.03329 12.7385 7.0347 12.7944 7.03745 12.8501H1.27026V12.8502ZM12.0341 14.3653C11.5845 14.8149 10.9868 15.0625 10.351 15.0625C9.7152 15.0625 9.11748 14.8149 8.66795 14.3653C8.21839 13.9158 7.97079 13.3181 7.97079 12.6823C7.97079 12.0466 8.21839 11.4488 8.66795 10.9993C9.13204 10.5352 9.74142 10.3032 10.351 10.3032C10.9605 10.3032 11.5701 10.5353 12.034 10.9993C12.9621 11.9273 12.9621 13.4373 12.0341 14.3653Z"
      fill="#13B56A"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
